import { ValueOf } from '../utilities/types';

const continents = {
  AF: 'AF',
  AN: 'AN',
  AS: 'AS',
  EU: 'EU',
  NA: 'NA',
  OC: 'OC',
  SA: 'SA',
} as const;

export type Continent = ValueOf<typeof continents>;

const continentNames = {
  [continents.AF]: 'Africa',
  [continents.AN]: 'Antarctica',
  [continents.AS]: 'Asia',
  [continents.EU]: 'Europe',
  [continents.NA]: 'North America',
  [continents.OC]: 'Oceania',
  [continents.SA]: 'South America',
} as const;

export const continentChoices = Object.entries(continentNames).map(([id, name]) => ({
  id,
  name,
}));

export default continents;
